import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import {useTranslation} from "react-i18next";

function Cards() {
    const { t } = useTranslation();

    return (
        <div className='cards'>
            <h1>{t("Projects")}</h1>
            <div className='cards__container'>
                <div className='cards__wrapper'>
                    <ul className='cards__items'>
                        <CardItem
                            src='/images/projects/VPR02639_Vasso_Paraschi.webp'
                            text='Commercial'
                            path='/projects'
                        />
                        <CardItem
                            src='/images/projects/VPR02373_Vasso_Paraschi.webp'
                            text='Residential'
                            path='/projects'
                        />
                        <CardItem
                            src='images/projects/VPR02427_Vasso_Paraschi.webp'
                            text='Hotels'
                            path='/projects'
                        />
                        <CardItem
                            src='images/projects/VPR02436_Vasso_Paraschi.webp'
                            text='Constructions'
                            path='/projects'
                        />
                        <CardItem
                            src='images/projects/VPR02523_Vasso_Paraschi.webp'
                            text='Constructions'
                            path='/projects'
                        />
                        <CardItem
                            src='images/projects/VPR02753_Vasso_Paraschi.webp'
                            text='Constructions'
                            path='/projects'
                        />
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Cards;
